import { Controller } from "@hotwired/stimulus";

import Dropzone from "dropzone";
//import { postJSON } from "lib/ajax";

export default class extends Controller {
  initialize() {
    console.log("song-dropzone init");
    Dropzone.autoDiscover = false;
  }

  connect() {
    console.log("init dz");

    var message =
      "<div class='fs-4 fw-bold'>Drop an <u>Audio File</u> Here</div>" +
      "<div class='btn btn-primary my-3 d-block fs-5'>Click to Browse for Audio File</div>" +
      "<ul class='rounded list-group list-group-flush border border-primary'>" +
      "<li class='list-group-item list-group-item-primary'>MP3, M4A, WAV</li>" +
      "<li class='list-group-item list-group-item-primary'>Less Than 30MB</li></ul>";

    $("#fileInput").dropzone({
      url: $("#fileInput").parent("form").attr("action"),
      maxFiles: 1,
      maxFilesize: 30_000_000,
      paramName: "airplay_song[mp3]",
      addRemoveLinks: true,
      autoProcessQueue: false,
      withCredentials: true,
      headers: { "X-FORWARDED-HOST": window.location.host },
      // previewsContainer: '#dropzonePreview',
      dictDefaultMessage: message,
      acceptedFiles:
        ".mp3,.mp4,.m4a,.aif,.aiff,.wav,.aac,audio/mpeg,audio/mp4,audio/x-aiff,audio/wav,audio/aac",
      error: function (file, message) {
        $(file.previewElement)
          .addClass("dz-error")
          .find(".dz-error-message")
          .text(message)
          .css({ opacity: 1 });
      },
      sending: function (file, xhr, formData) {
        $("#airplay_song_upload input[type=hidden]").each(function (i, e) {
          formData.append($(e).attr("name"), $(e).val());
        });
        formData.append("airplay_song[title]", $("#airplay_song_title").val());
      },
      success: function (file, json) {
        // onward.song = true;
        $("#airplay_song_submit").prop("disabled", true).hide();
        $(file.previewElement).text(json.message);
        if (json.next_url) {
          // console.log("dz success JSON", json)
          setTimeout(function () {
            Turbo.visit(json.next_url);
          }, 3000);
        }
        // check();
      },
      // addedfile: function(_file){
      //  if($('#airplay_song_title').val().length > 2){
      //    $("#airplay_song_submit").removeClass("btn-secondary").addClass("btn-success");
      //  }
      // },
      init: function () {
        //  ASUDropzone = this;
        this.on("maxfilesexceeded", function (file) {
          this.removeFile(this.files[0]);
          alert("Please, one file at a time.");
        });
      },
    });

    this.dz = $("#fileInput").get(0).dropzone;
    this.attach();
  }

  attach() {
    this.dz.on("addedfile", function () {
      if ($("#airplay_song_title").val().length > 2) {
        $("#airplay_song_submit")
          .removeClass("btn-secondary")
          .addClass("btn-success");
      }
    });
    // future
    // $("#airplay_song_mp3_url").keyup(function () {
    //   if (
    //     $(this).val().length > 7 &&
    //     $("#airplay_song_title").val().length > 2
    //   ) {
    //     $("#airplay_song_submit")
    //       .removeClass("btn-secondary")
    //       .addClass("btn-success");
    //   } else {
    //     $("#airplay_song_submit")
    //       .removeClass("btn-success")
    //       .addClass("btn-secondary");
    //   }
    // });
  }

  submitClick(event) {
    event.preventDefault();

    if ($("#airplay_song_title").val().length > 2) {
      if (this.dz.getAcceptedFiles().length > 0) {
        this.dz.processQueue();
      } else if ($("#airplay_song_mp3_url")?.val()?.length > 15) {
        if (!$("#airplay_song_mp3_url")[0].checkValidity()) {
          alert("Please check the URL is valid");
          return false;
        }
        $.ajax({
          url: $("#airplay_song_upload").attr("action"),
          data: {
            autheticity_token: $(
              "#airplay_song_upload input[name=authenticity_token]"
            ).val(),
            airplay_song: {
              title: $("#airplay_song_title").val(),
              mp3_url: $("#airplay_song_mp3_url").val(),
            },
          },
          headers: {
            "X-CSRF-Token": $(
              "#airplay_song_upload input[name=authenticity_token]"
            ).val(),
          },
          xhrFields: { withCredentials: true },
          dataType: "json",
          method: "POST",
          success: (data) => {
            setTimeout(() => {
              Turbo.visit(data.next_url);
            }, 10);
          },
          error: (jq, status, error) => {
            console.log("DZ error:", jq, status, error);
            if (jq?.responseJSON?.message) {
              alert(jq?.responseJSON?.message);
            } else {
              alert("Oops. Please check your information and try again");
            }
          },
        });
      } else {
        alert("Please Browse for a File");// or Enter a URL for your song file");
      }
    } else {
      alert("Please add a Song Title of at least 3 characters");
    }
  }

  titleKey(e) {
    // console.log($(e.target));
    if (
      $(e.target).val().length > 2 &&
      (this.dz.getAcceptedFiles().length > 0 ||
        $("#airplay_song_mp3_url")?.val()?.length >= 15)
    ) {
      $("#airplay_song_submit")
        .removeClass("btn-secondary")
        .addClass("btn-success");
    } else {
      $("#airplay_song_submit")
        .removeClass("btn-success")
        .addClass("btn-secondary");
    }
  }

  disconnect() {
    console.log("destroy dz");
    this.dz.destroy();
  }
}
